import { createContext, useContext, useState, ReactNode } from "react";

interface ValuesVisibilityContextType {
  visible: boolean;
  toggle: () => void;
  mask: (value: string) => string;
}

const ValuesVisibilityContext = createContext<ValuesVisibilityContextType>({
  visible: false,
  toggle: () => {},
  mask: () => "*****",
});

export function ValuesVisibilityProvider({ children }: { children: ReactNode }) {
  const [visible, setVisible] = useState(false);

  const toggle = () => setVisible((v) => !v);

  const mask = (value: string) => (visible ? value : "*****");

  return (
    <ValuesVisibilityContext.Provider value={{ visible, toggle, mask }}>
      {children}
    </ValuesVisibilityContext.Provider>
  );
}

export function useValuesVisibility() {
  return useContext(ValuesVisibilityContext);
}
